/**
 * Formats a numeric amount with thousands separators and the display currency.
 * XAF is shown as "FCFA". Trailing ".00" is dropped while real decimals are kept
 * (e.g. 555000 -> "555,000 FCFA", 157365.46 -> "157,365.46 FCFA").
 */
export const formatAmount = (
  value: number | null | undefined,
  currency?: string | null,
): string => {
  const displayCurrency = currency === "XAF" ? "FCFA" : currency || "FCFA";
  const amount = Number.isFinite(value as number) ? (value as number) : 0;
  const formatted = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
  }).format(amount);
  return `${formatted} ${displayCurrency}`;
};
